export enum PermissionWSExecution {
  /** Výpis SOAP volání  */
  WS_EXECUTION_LIST = 'WS_EXECUTION_LIST',

  /** Detail SOAP volání */
  WS_EXECUTION_DETAIL = 'WS_EXECUTION_DETAIL',
}
